import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Container from 'react-bootstrap/Container';

import PdfContainer from '../../atoms/PdfContainer/PdfContainer';

const PdfViewer = (props) => {
  const { signatureRequestId } = props;

  useEffect(() => {
    const script = document.createElement('script');
    script.setAttribute('src', 'https://documentcloud.adobe.com/view-sdk/viewer.js');
    script.setAttribute('id', 'adobe-embed-api');
    document.body.appendChild(script);

    function cleanup() {
      document.body.removeChild(document.getElementById('adobe-embed-api'));
    }

    return cleanup;
  });

  return (
    <Container>
      <PdfContainer signatureRequestId={signatureRequestId} />
    </Container>
  );
};

PdfViewer.propTypes = {
  signatureRequestId: PropTypes.string.isRequired,
};

export default PdfViewer;
